import { Sheet } from "react-modal-sheet";
import styles from "src/features/Event/components/TopPageFilterModal/topPageFilterModal.module.css";
import baseStyles from "src/global.module.css";
import Creatable from "react-select/creatable";
import { SelectPlaceOptionsForKobe } from "../../event.constant";
import DateTmeSelectorOfFilterModalSheet from "../DateTimeSelectorOfFilterModalSheet/DateTimeSelectorOfFilterModalSheet";
import EventPriceSelectorOfFilterModalSheet from "../EventPriceSelectorOfFilterModalSheet/EventPriceSelectorOfFilterModalSheet";
import useTopPageFilterModal from "../../hooks/useTopPageFilterModal";

export type TopPageFilterModalProps = {
    isModalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const TopPageFilterModal: React.FC<TopPageFilterModalProps> = (props) => {
    const {
        searchKeyword,
        setSearchKeyword,
        artistSearchKeyword,
        setArtistSearchKeyword,
        placeSearchKeyword,
        setPlaceSearchKeyword,
        handelCloseModal,
        handelApply,
        handelCancel,
    } = useTopPageFilterModal(props);

    return (
        <Sheet
            isOpen={props.isModalOpen}
            onClose={handelCloseModal}
            detent="content-height"
        >
            <Sheet.Container>
                <Sheet.Content>
                    <Sheet.Scroller>
                        <div className={baseStyles.modal_content_container}>
                            <div className={baseStyles.mb24} />
                            <h1>フィルター</h1>
                            <div className={baseStyles.mb24} />
                            {/* アーティスト検索 */}
                            <h2>アーティスト</h2>
                            <div className={baseStyles.mb8} />
                            <div className={styles.search_container}>
                                <input
                                    className={styles.search_input}
                                    type="text"
                                    placeholder=",(カンマ)区切りで複数入力可能です"
                                    value={
                                        artistSearchKeyword !== ""
                                            ? artistSearchKeyword
                                            : ""
                                    }
                                    onChange={(e) => {
                                        setArtistSearchKeyword(e.target.value);
                                    }}
                                />
                                <div className={styles.magnifying_glass} />
                            </div>
                            <div className={baseStyles.mb24} />
                            {/* キーワード検索 */}
                            <h2>キーワード</h2>
                            <div className={baseStyles.mb8} />
                            <div className={styles.search_container}>
                                <input
                                    className={styles.search_input}
                                    type="text"
                                    placeholder="例)Street,路上ライブ,神戸"
                                    value={
                                        searchKeyword !== null
                                            ? searchKeyword
                                            : ""
                                    }
                                    onChange={(e) => {
                                        setSearchKeyword(e.target.value);
                                    }}
                                />
                                <div className={styles.magnifying_glass} />
                            </div>
                            <div className={baseStyles.mb24} />
                            {/* 開催場所検索 */}
                            <h2>開催場所</h2>
                            <div className={baseStyles.mb8} />
                            <Creatable
                                options={[
                                    { value: "", label: "指定しない" },
                                    ...SelectPlaceOptionsForKobe,
                                ]}
                                captureMenuScroll
                                placeholder="リストから選ぶか、地名などを入力してください"
                                closeMenuOnScroll
                                defaultInputValue={
                                    placeSearchKeyword !== ""
                                        ? placeSearchKeyword
                                        : ""
                                }
                                onChange={(value) => {
                                    setPlaceSearchKeyword(value?.value ?? "");
                                }}
                                onInputChange={(inputValue) => {
                                    // onChangeとonInputChangeの両方が走るため、
                                    if (
                                        inputValue !== null &&
                                        inputValue !== ""
                                    ) {
                                        setPlaceSearchKeyword(inputValue);
                                    }
                                }}
                                noOptionsMessage={() => {
                                    return "半角数字、分単位で入力してください。";
                                }}
                                formatCreateLabel={(inputValue) => {
                                    return `${inputValue}で検索`;
                                }}
                                classNames={{
                                    control: () => {
                                        return `${styles.react_select_container}`;
                                    },
                                    indicatorSeparator: () => {
                                        return `${styles.indicator_separator}`;
                                    },
                                    valueContainer: () => {
                                        return ` ${
                                            placeSearchKeyword !== ""
                                                ? styles.react_select_value
                                                : ""
                                        }`;
                                    },
                                }}
                            />
                            <div className={baseStyles.mb24} />
                            {/* 日時検索 */}
                            <h2>日時</h2>
                            <div className={baseStyles.mb8} />
                            <DateTmeSelectorOfFilterModalSheet />
                            <div className={baseStyles.mb24} />
                            {/* 料金別 */}
                            <h2>料金</h2>
                            <div className={baseStyles.mb8} />
                            <EventPriceSelectorOfFilterModalSheet />
                            <div className={baseStyles.mb32} />
                            <div className={styles.buttons_container}>
                                <div
                                    className={`${styles.button} ${styles.cancel}`}
                                    onClick={handelCancel}
                                    onKeyDown={handelCancel}
                                    role="button"
                                    tabIndex={0}
                                >
                                    キャンセル
                                </div>
                                <div
                                    className={`${styles.button} ${styles.register}`}
                                    onClick={handelApply}
                                    onKeyDown={handelApply}
                                    role="button"
                                    tabIndex={0}
                                >
                                    適用
                                </div>
                            </div>
                        </div>
                    </Sheet.Scroller>
                </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onTap={handelCloseModal} />
        </Sheet>
    );
};

export default TopPageFilterModal;
